import React from 'react';
import glamorous from 'glamorous';
import { MENU_ENTRIES } from '../constants';
import ImgWithSource from '../img-with-source';
import xmlValidator2Img from '../../../../assets/images/docs/xml-validation/xmlValidation2.png';
import xmlValidator3Img from '../../../../assets/images/docs/xml-validation/xmlValidation3.png';
import xmlValidatorCoreFilingImg from '../../../../assets/images/docs/xml-validation/xmlValidatorCoreFiling.png';
import xmlValidatorErrImg from '../../../../assets/images/docs/xml-validation/xmlValidationErr.png';

const ValidationFiles = ({ onSectionChange }) => (
  <div data-subsection={MENU_ENTRIES.xmlValidationSteps}>
    <h4>Validation steps</h4>
    <glamorous.Ul
      className="pt-list"
      css={{ listStyle: 'decimal' }}
    >
      <li>Using the CoreFiling XML Schema Validator, browse and select the XML schema for validation (globalrecall.xsd
        or globalrecall4Deletion.xsd).
      </li>
      <li>Browse and select your XML file to be validated (i.e. the XML instance) on your computer.</li>
      <li>Validate the XML file against the XSD schema by clicking the “Validate” button.</li>
    </glamorous.Ul>
    <ImgWithSource src={xmlValidatorCoreFilingImg} source="http://www.corefiling.com/opensource/schemaValidate"/>
    <br/><br/>
    <div>
      <p>
        The validator will first check whether both files have been submitted for review.
      </p>
      <ImgWithSource
        src={xmlValidator2Img}
        source="http://www.corefiling.com/opensource/schemaValidate"
      />
    </div>
    <br/><br/>
    <div>
      <p>
        If there are no errors, the validator will confirm with the message <strong>"
        <glamorous.Span css={{ color: 'rgb(146,208,80)' }}>VALID</glamorous.Span>
        "</strong>.
      </p>
      <ImgWithSource src={xmlValidator3Img} source="http://www.corefiling.com/opensource/schemaValidate"/>
    </div>
    <br/><br/>
    <div>
      <p>
        If there are errors, the validator will provide a brief description of each error. Take note of the error
        messages and update the XML file accordingly. As an example, the error in the screenshot below notes that the
        “&” character is present in the XML file and has not been <a
        onClick={e => onSectionChange(MENU_ENTRIES.htmlEncoding)}>HTML-encoded</a> (i.e it has not been changed from “&”
        to {`“&amp;”`}).
      </p>
      <ImgWithSource src={xmlValidatorErrImg} source="http://www.corefiling.com/opensource/schemaValidate"/>
    </div>
  </div>
);

export default ValidationFiles;



// WEBPACK FOOTER //
// ./src/views/static/import-documentation/xml-validation/validation-steps.js